import {useMemo, useState} from 'react';
import {Box, Stack} from '@mui/material';
import {useDispatch} from 'react-redux';
import GlobalDialog from '../../../components/dialogs/MessageOk';
import {StudentSingleTrackTile} from './MusicSelectionDataGrid';
import {IMediaTrack} from '../../../dto/MediaTrack.dto';
import InputSearch from '../../../components/styles/InputSearch';
import {closePlayer} from '../../../store/Slices/playerSlice';

const StudentMusicSelectionDialog = ({
  onClose,
  selectedSongs,
  selectedSongIds,
  setSelectedSongs,
  setSelectedSongIds,
}: {
  onClose: () => void;
  selectedSongs: IMediaTrack[];
  selectedSongIds: number[];
  setSelectedSongs: React.Dispatch<React.SetStateAction<IMediaTrack[]>>;
  setSelectedSongIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const searchedValues = useMemo(
    () =>
      selectedSongs.filter(
        v =>
          !search ||
          v.track_name.toLowerCase().includes(search.toLowerCase()) ||
          v.track_artist.toLowerCase().includes(search.toLowerCase()),
      ),
    [search, selectedSongs],
  );
  const handleClose = () => {
    dispatch(closePlayer()); // Stop any playing song
    onClose();
  };
  return (
    <GlobalDialog
      dialogTitle='Selected Song(s)'
      dialogProps={{open: true, fullWidth: true, maxWidth: 'xs'}}
      dialogContent={
        <Stack className='h-full' spacing={1}>
          <Stack
            className='w-full mt-2'
            spacing={1}
            direction='row'
            justifyContent='center'
            alignItems='center'>
            <InputSearch
              className='max-w-250'
              placeholder='Search'
              value={search}
              onChange={val => setSearch(val)}
            />
          </Stack>
          <Box className='max-h-500 scrollbar overflow-auto w-full'>
            {searchedValues.map(track => (
              <StudentSingleTrackTile
                key={track.id}
                track={track}
                selectedSongIds={selectedSongIds}
                setSelectedSongIds={setSelectedSongIds}
                setSelectedSongs={setSelectedSongs}
                isChipVisible={false}
                isDeleteIcon={true}
              />
            ))}
          </Box>
        </Stack>
      }
      onClose={handleClose}
    />
  );
};

export default StudentMusicSelectionDialog;
